import React, { useEffect, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import PencilIcon from "mdi-react/PencilIcon";
import PopupWrapper from "../PopupWrapper";
import { useForm } from "react-hook-form";
import InputBox from "./InputBox";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

const UsePencil = ({
  className,
  title,
  popupTitle,
  register,
  field,
  error,
  watch,
  setValue,
}) => {
  const [showPopup, setshowPopup] = useState(false);
  const [value, setvalue] = useState("");

  useEffect(() => {
    setValue(field, value);
  }, [setValue, value]);

  return (
    <div className={`form-group rounded ${className}`}>
      <InputGroup
        className="input-lg"
        style={
          error?.length && !value
            ? { height: "50px", border: "1px solid #dc3545" }
            : { height: "50px", border: "1px solid #ced4da" }
        }
      >
        <Button
          variant="outline-primary border-0 border-end"
          id="button-addon1"
          onClick={() => setshowPopup(true)}
        >
          <PencilIcon />
        </Button>
        <Form.Control
          aria-label="Example text with button addon"
          aria-describedby="basic-addon1"
          className="border-0"
          placeholder={title}
          {...register(field)}
          value={watch(field)}
          disabled
        />
      </InputGroup>
      {error?.length && !value && (
        <div className="d-block invalid-feedback">{error}</div>
      )}
      <PencilForm
        showPopup={showPopup}
        setshowPopup={setshowPopup}
        title={popupTitle}
        setvalue={setvalue}
      />
    </div>
  );
};

export default UsePencil;

const PencilForm = ({ showPopup, setshowPopup, title, setvalue }) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    clearErrors,
    reset,
  } = useForm({ mode: "onBlur", ...salGeneralFormOptions });

  const value = watch("P76_PMTPIMain");
  //   const [selectedOption, setSelectedOption] = useState("Current P & I");

  useEffect(() => {
    register("P76_PMTPIMain");
    setValue("P76_PMTPIMain", "CurrentPI");
  }, [register, setValue]);

  //   const handleOptionChange = (event) => {
  //     setSelectedOption(event.target.value);
  //   };

  function onsubmit(data) {
    setvalue(data[`${value}Amount`]);
    setshowPopup(false);
    // reset();
  }

  return (
    <PopupWrapper
      title={title}
      Component={
        <div className="container-fluid p-3 rounded">
          <h5 className="text-primary mb-3">Select New P & I Amount</h5>
          <div className="">
            {/* {paymentOptions.map((option, index) => (
              <div
                key={index}
                className=" d-flex align-items-center justify-content-between my-3"
              >
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="paymentOption"
                    id={option.label}
                    value={option.label}
                    checked={selectedOption === option.label}
                    onChange={handleOptionChange}
                  />
                  
                  <label className="form-check-label" htmlFor={option.label}>
                    {option.label}
                  </label>
                </div>
                <input type="text" disabled={selectedOption !== option.label} />
              </div>
            ))} */}
            {paymentOptions.map((option, index) => (
              <div
                key={index}
                className=" d-flex align-items-center justify-content-between my-3"
              >
                <Form.Check
                  key={index}
                  type={"radio"}
                  label={option.title}
                  id={option.title}
                  isInvalid={errors?.["P76_PMTPIMain"]}
                  checked={value === option.value}
                  onChange={(e) => {
                    clearErrors();
                    setValue("P76_PMTPIMain", option.value);
                  }}
                  className={
                    errors?.["P76_PMTPIMain"]?.message && value === undefined
                      ? "is-invalid"
                      : ""
                  }
                />
                <InputBox
                  {...inputFields[index]}
                  errors={errors}
                  watch={watch}
                  setValue={setValue}
                  register={register}
                />
              </div>
            ))}
          </div>

          {/* Action Buttons */}
          <div className="d-flex justify-content-end mt-5 gap-5">
            <button
              type="button"
              className="btn btn-primary me-2"
              onClick={handleSubmit(onsubmit)}
            >
              OK
            </button>
            <button
              type="button"
              className="btn btn-secondary border"
              onClick={() => setshowPopup(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      }
      toShow={showPopup}
      extraClass={"min-width-50vw"}
      closeEventHandler={() => {
        setshowPopup(false);
        setValue(`${value}Amount`, "")
        // reset();
      }}
      titleClassName={"w-100"}
    />
  );
};

const paymentOptions = [
  { title: "Current P & I", value: "CurrentPI" },
  {
    title: "Fully Amortized (To Term)",
    value: "FullyAmortizedToTerm",
  },
  {
    title: "Fully Amortized (30 years)",
    value: "FullyAmortized30Years",
  },
  {
    title: "Fully Amortized (25 years)",
    value: "FullyAmortized25Years",
  },
  {
    title: "Fully Amortized (15 years)",
    value: "FullyAmortized15Years",
  },
  { title: "Interest Only", value: "InterestOnly" },
  { title: "Constant Amortization", value: "ConstantAmortization" },
];

const inputFields = [
  {
    title: "Current P & I",
    field: "CurrentPIAmount",
    type: "number",
    defaultValue: "",
    className: "col-6",
    dependsOn: [
      {
        field: "P76_PMTPIMain",
        value: "CurrentPI",
      },
    ],
    show: true,
  },
  {
    title: "Fully Amortized (To Term)",
    field: "FullyAmortizedToTermAmount",
    type: "number",
    defaultValue: "",
    className: "col-6",
    dependsOn: [
      {
        field: "P76_PMTPIMain",
        value: "FullyAmortizedToTerm",
      },
    ],
    show: true,
  },
  {
    title: "Fully Amortized (30 years)",
    field: "FullyAmortized30YearsAmount",
    type: "number",
    defaultValue: "",
    className: "col-6",
    dependsOn: [
      {
        field: "P76_PMTPIMain",
        value: "FullyAmortized30Years",
      },
    ],
    show: true,
  },
  {
    title: "Fully Amortized (25 years)",
    field: "FullyAmortized25YearsAmount",
    type: "number",
    defaultValue: "",
    className: "col-6",
    dependsOn: [
      {
        field: "P76_PMTPIMain",
        value: "FullyAmortized25Years",
      },
    ],
    show: true,
  },
  {
    title: "Fully Amortized (15 years)",
    field: "FullyAmortized15YearsAmount",
    type: "number",
    defaultValue: "",
    className: "col-6",
    dependsOn: [
      {
        field: "P76_PMTPIMain",
        value: "FullyAmortized15Years",
      },
    ],
    show: true,
  },
  {
    title: "Interest Only",
    field: "InterestOnlyAmount",
    type: "number",
    defaultValue: "",
    className: "col-6",
    dependsOn: [
      {
        field: "P76_PMTPIMain",
        value: "InterestOnly",
      },
    ],
    show: true,
  },
  {
    title: "Constant Amortization",
    field: "ConstantAmortizationAmount",
    type: "number",
    defaultValue: "",
    className: "col-6",
    dependsOn: [
      {
        field: "P76_PMTPIMain",
        value: "ConstantAmortization",
      },
    ],
    show: true,
  },
];

const salGeneralSchema = Yup.object().shape({
  P76_PMTPIMain: Yup.string().required("P & I selection is mandatory"),
  CurrentPIAmount: Yup.string().when("P76_PMTPIMain", {
    is: "CurrentPI",
    then: (schema) => schema.required("Current P & I Amount is mandatory"),
  }),
  FullyAmortizedToTermAmount: Yup.string().when("P76_PMTPIMain", {
    is: "FullyAmortizedToTerm",
    then: (schema) =>
      schema.required("Fully Amortized (To Term) Amount is mandatory"),
  }),
  FullyAmortized30YearsAmount: Yup.string().when("P76_PMTPIMain", {
    is: "FullyAmortized30Years",
    then: (schema) =>
      schema.required("Fully Amortized (30 years) Amount is mandatory"),
  }),
  FullyAmortized25YearsAmount: Yup.string().when("P76_PMTPIMain", {
    is: "FullyAmortized25Years",
    then: (schema) =>
      schema.required("Fully Amortized (25 years) Amount is mandatory"),
  }),
  FullyAmortized15YearsAmount: Yup.string().when("P76_PMTPIMain", {
    is: "FullyAmortized15Years",
    then: (schema) =>
      schema.required("Fully Amortized (15 years) Amount is mandatory"),
  }),
  InterestOnlyAmount: Yup.string().when("P76_PMTPIMain", {
    is: "InterestOnly",
    then: (schema) => schema.required("Interest Only Amount is mandatory"),
  }),
  ConstantAmortizationAmount: Yup.string().when("P76_PMTPIMain", {
    is: "ConstantAmortization",
    then: (schema) =>
      schema.required("Constant Amortization Amount is mandatory"),
  }),
});

export const salGeneralFormOptions = {
  resolver: yupResolver(salGeneralSchema),
};
